import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Form, Input, Button, Spin} from 'antd';
import {LockOutlined} from '@ant-design/icons';
import {hasErrors} from '../../helpers';
import register from '../../Actions/register';
import {getValueFromQueryString} from '../../helpers';
import user from '../../Actions/user';

const {registerUserFreePlan, setNewPassword, requestValidatePasswordToken} = register.actions;

const {getPreUserData} = user.actions;
const labels = {
    activateAccount: {
        title: 'Activa tu cuenta',
        description: 'Solo un paso más, por favor confirmar la contraseña de tu cuenta y podrás hacer uso de los beneficios de',
        button: 'Activar',
    },
    changePassword: {
        title: 'Recuperar contraseña',
        description: 'Ingresa tu nueva contraseña para seguir disfrutando de los beneficios de',
        button: 'Guardar Contraseña'
    }
}

let currentPath = 'changePassword';
let email = '';
let token = '';

function ActiveAccount(props) {
    const {history} = props;
    const [form] = Form.useForm();
    //this is the equivalent to didMount
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        email = urlParams.get('email');
        if (window.location.pathname.includes('active-account'))
            currentPath = 'activateAccount';
        else {
            token = urlParams.get('token');
            props.requestValidatePasswordToken({token, history, email});
        }
    }, []);

    const handleSubmit = values => {
        if (currentPath === 'changePassword')
            props.setNewPassword({email, password: values.password, history, token});
        else
            props.registerUserFreePlan({email: email, password: values.password, history});
    };

    return (
        <div className="exterior-container">
            <div className="inner-exterior-container" style={{justifyContent: 'space-around'}}>
                <div className="info-container" style={{maxWidth: '300px'}}>
                    <img src="./img/logo-efisco.png" alt="efisco" style={{marginBottom: '20px'}}/>
                    <h2 className="blue-text register-title title-text"
                        style={{marginBottom: 0}}>{labels[currentPath].title}</h2>
                    <p className="label">
                        {labels[currentPath].description} <span className="blue-text">SW smarter® efisco</span>
                    </p>
                </div>
                <Form layout="vertical" form={form} onFinish={handleSubmit} autoComplete="off" style={{width: '50%'}}>
                    <div style={{marginBottom: '10px'}}>
                        <h2 className="blue-text" style={{marginBottom: 0}}>Cuenta</h2>
                        <em className="em">{email}</em>
                    </div>
                    <Form.Item
                        label="Contraseña"
                        name="password"
                        rules={
                            [
                                {required: true, message: '¡Favor de introducir su contraseña!'},
                            ]
                        }
                    >
                        <Input.Password
                            prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}
                            type="password"
                            placeholder=""
                            visibilityToggle={true}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Confirmar contraseña"
                        name="repassword"
                        dependencies={['pasword']}
                        rules={
                            [
                                {required: true, message: '¡Favor de confirmar su contraseña!'},
                                ({getFieldValue}) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Las contraseñas no coinciden'));
                                    },
                                }),
                            ]
                        }
                    >
                        <Input.Password
                            prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}
                            type="password"
                            placeholder=""
                            visibilityToggle={true}
                        />
                    </Form.Item>
                    <Form.Item>
                        <div className="center-button-login">
                            <Button type="primary" htmlType="submit">
                                {labels[currentPath].button}
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
                {props.isLoading &&
                    <div className="loading-container">
                        <Spin size="large" tip="Cargando"/>
                    </div>
                }
            </div>
        </div>
    )
}


const mapStateToProps = state => {
    return {
        isLoading: state._genericComponents.loading.isCurrentlyLoading,
        preUserData: state.user.preUserData,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        dispatch,
        ...bindActionCreators({
            registerUserFreePlan,
            setNewPassword,
            getPreUserData,
            requestValidatePasswordToken
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActiveAccount);